export var PusherChannel;
(function (PusherChannel) {
    PusherChannel["Presence"] = "presence";
    PusherChannel["Private"] = "private";
    PusherChannel["User"] = "user";
    PusherChannel["Business"] = "business";
    PusherChannel["Chat"] = "chat";
})(PusherChannel || (PusherChannel = {}));
//# sourceMappingURL=pusher-channel.const.js.map